/**
 * Arma el objeto de config de axios con `params`, descartando los valores vacíos.
 */
export const withParams = (params = {}) => ({
  params: Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
  ),
});
